exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filesView .v-text-field__details {\n    position: absolute !important;\n    z-index: -1 !important;\n    display: none;\n}\n.filesView .v-input__slot {\n    margin-bottom: auto;\n}\n\n", ""]);
